import controller from "emun.cart/order-confirmation.controller";
import templateUrl from "emun.cart/order-confirmation.htm";

export default {
  bindings: {
		orderNumber: "@",
		orderNumbers: "@",
    selfcheckout: "@"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
